import { useTranslation } from 'react-i18next';

const benefits = [
  { icon: 'ri-heart-2-line', color: 'text-rose-500', bg: 'bg-rose-50', titleKey: 'wb1_title', textKey: 'wb1_text' },
  { icon: 'ri-cup-line', color: 'text-sky-500', bg: 'bg-sky-50', titleKey: 'wb2_title', textKey: 'wb2_text' },
  { icon: 'ri-money-dollar-circle-line', color: 'text-emerald-500', bg: 'bg-emerald-50', titleKey: 'wb3_title', textKey: 'wb3_text' },
  { icon: 'ri-tools-line', color: 'text-amber-500', bg: 'bg-amber-50', titleKey: 'wb4_title', textKey: 'wb4_text' },
  { icon: 'ri-user-smile-line', color: 'text-violet-500', bg: 'bg-violet-50', titleKey: 'wb5_title', textKey: 'wb5_text' },
  { icon: 'ri-earth-line', color: 'text-teal-500', bg: 'bg-teal-50', titleKey: 'wb6_title', textKey: 'wb6_text' },
];

export default function WaterBenefits() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Benefits */}
          <div>
            <span className="text-sky-600 text-sm font-bold uppercase tracking-widest">{t('wb_tag')}</span>
            <h2 className="text-4xl font-black text-slate-800 mt-3 mb-8 leading-tight">
              {t('wb_title1')}<br />{t('wb_title2')}
            </h2>
            <div className="space-y-5">
              {benefits.slice(0, 4).map((b) => (
                <div key={b.titleKey} className="flex items-start gap-4">
                  <div className={`w-10 h-10 ${b.bg} rounded-xl flex items-center justify-center shrink-0`}>
                    <i className={`${b.icon} ${b.color} text-xl`}></i>
                  </div>
                  <div>
                    <h4 className="text-slate-800 font-bold text-sm mb-1">{t(b.titleKey)}</h4>
                    <p className="text-slate-500 text-sm leading-relaxed">{t(b.textKey)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Image + remaining benefits */}
          <div>
            <div className="rounded-2xl overflow-hidden h-64 mb-6">
              <img
                src="https://public.readdy.ai/ai/img_res/a4ffa32935c2bbb6e145840524c7921c.jpg"
                alt="Family enjoying clean water"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="space-y-5">
              {benefits.slice(4).map((b) => (
                <div key={b.titleKey} className="flex items-start gap-4">
                  <div className={`w-10 h-10 ${b.bg} rounded-xl flex items-center justify-center shrink-0`}>
                    <i className={`${b.icon} ${b.color} text-xl`}></i>
                  </div>
                  <div>
                    <h4 className="text-slate-800 font-bold text-sm mb-1">{t(b.titleKey)}</h4>
                    <p className="text-slate-500 text-sm leading-relaxed">{t(b.textKey)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
